module.exports = __webpack_public_path__ + "img/404-error.d0420da2.svg";